import React from 'react';

type State = {
    value    : number;
};

type SliderProps = {
    name      : string;
    input     : number;
    steps     : number;
    minValue  : number;
    maxValue  : number;
    offWhen?  : number;
    stepSize? : number;


    onChange : (value : number) => void;
};

export class SliderComp extends React.Component<SliderProps, State> {

    constructor(props: SliderProps) {
        super(props);
        this.state = {
            value : props.input
        }
    }

    handleChange(e : React.ChangeEvent<HTMLInputElement>)
    {
        const value = parseFloat(e.target.value);

        this.setState({
            value : value
        });

        this.props.onChange(value);
    }

    displayValue() : string
    {
        if (this.state.value === this.props.offWhen) {
            return "Off";
        }

        return this.state.value.toFixed(1)
    }

    render() {
        let stepSize = 0.0001;
        if (this.props.stepSize !== undefined) {
            stepSize = this.props.stepSize;
        }

        return (
          <>
          <label className="labelStyle" htmlFor="steps">{ this.props.name }</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <input
              style={{ flex: 1 }}
              id="steps"
              name="steps"
              type="range"
              min={this.props.minValue}
              max={this.props.maxValue}
              value={this.state.value}
              step={stepSize}
              onChange={(e) => this.handleChange(e) }
            />
            <span style={{ minWidth: '2.5rem', textAlign: 'center', fontWeight: 'bold' }}>
              { this.displayValue() }
            </span>
          </div>
          </>
        );
      }
}

